"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
var getHeader = function getHeader(offer) {
  var _offer$offerTypes;
  var value = offer === null || offer === void 0 || (_offer$offerTypes = offer.offerTypes) === null || _offer$offerTypes === void 0 || (_offer$offerTypes = _offer$offerTypes[0]) === null || _offer$offerTypes === void 0 || (_offer$offerTypes = _offer$offerTypes.slogan) === null || _offer$offerTypes === void 0 ? void 0 : _offer$offerTypes[0];
  if ((0, _fp.isNil)(value)) return null;
  return {
    type: 'portableText',
    value: value
  };
};
var _default = exports["default"] = getHeader;
module.exports = exports.default;